module.exports = __webpack_public_path__ + "static/img/wuhanpu1.5895382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wuhanpu1.png
// module id = aCo7
// module chunks = 1